/** How long before the start a cancel or delete by staff must come for the reservation to free the monthly quota. */
export const STAFF_CANCEL_FREES_QUOTA_HOURS = 12

export interface ReservationQuotaFacts {
  start: Date | string
  cancelledAt?: Date | string | null
  deletedAt?: Date | string | null
  /** The customer cancelled it themself, through the link in their e-mail. */
  cancelledByCustomer: boolean
}

/**
 * Whether a reservation counts against the month it was created in (docs/billing.md, _Counting rules_). It is freed
 * only when
 *
 * - the customer cancelled it through their link before the start, or
 * - staff cancelled or deleted it at least `STAFF_CANCEL_FREES_QUOTA_HOURS` before the start.
 *
 * Without the second rule's margin, staff could cancel a booking silently just before it starts - the client still
 * comes - and get the reservation free. `RESERVATION_QUOTA_SQL` in `libs/database/src/operations/account-usage.ts`
 * computes the same rule in SQL and must stay in step with this one.
 */
export function reservationConsumesQuota(reservation: ReservationQuotaFacts): boolean {
  const start = new Date(reservation.start).getTime()
  if (reservation.cancelledAt && reservation.cancelledByCustomer) {
    return new Date(reservation.cancelledAt).getTime() >= start
  }
  const endedAt = reservation.cancelledAt ?? reservation.deletedAt
  if (!endedAt) {
    return true
  }
  return new Date(endedAt).getTime() > start - STAFF_CANCEL_FREES_QUOTA_HOURS * 3_600_000
}
